export const QA_NAME_FLAT_FORM_INHABITANT = 'inhabitant'
